import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { routeConfig } from "@monorepo/constants/routeConfig";
import theme, { iconsSizes } from "@monorepo/styles/theme";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

interface IPaymentsButtonProps {
  eventName?: string;
  disabled?: boolean;
}

const AddButton = styled(Button)(() => ({
  marginBottom: theme.spacing(2),
}));

export const PaymentsButton: React.FC<IPaymentsButtonProps> = ({ eventName, disabled, children }) => {
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <AddButton
      variant="contained"
      disabled={disabled}
      type="button"
      disableElevation
      sx={{ marginBottom: theme.spacing(2) }}
      startIcon={<AddCircleOutlineIcon sx={{ width: 30, height: 30, fontSize: iconsSizes.small }} />}
      onClick={() => {
        if (eventName) {
          ReactGA.event(eventName);
        }
        history.push(routeConfig.dashboard.payments.addService.self);
      }}
    >
      {children || t("payments.new_payment")}
    </AddButton>
  );
};
